export default "__VITE_ASSET__BZ93JIAx__"